import { render, staticRenderFns } from "./TableRefresh.vue?vue&type=template&id=0dcb2b52&scoped=true"
import script from "./TableRefresh.vue?vue&type=script&lang=js"
export * from "./TableRefresh.vue?vue&type=script&lang=js"
import style0 from "./TableRefresh.vue?vue&type=style&index=0&id=0dcb2b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcb2b52",
  null
  
)

export default component.exports